import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import { PaprikaFreshness } from '../../styles/theme';
import { FreshnessState } from '../../services/pantryFreshnessService';
import { freshnessDaysLabel } from './freshnessLabel';

interface Props {
  state: FreshnessState;
  days: number | null;
  compact?: boolean;
}

export function FreshnessPill({ state, days, compact = true }: Props) {
  const { t } = useTranslation();
  const f = PaprikaFreshness[state];
  return (
    <View style={[styles.pill, { backgroundColor: f.bg }, !compact && styles.big]}>
      <View style={[styles.dot, { backgroundColor: f.dot }]} />
      <Text style={[styles.label, { color: f.text }, !compact && styles.labelBig]} numberOfLines={1}>
        {freshnessDaysLabel(t, days, state)}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  pill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingVertical: 3,
    paddingHorizontal: 9,
    borderRadius: 999,
    alignSelf: 'flex-start',
  },
  big: {
    paddingVertical: 5,
    paddingHorizontal: 10,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 999,
  },
  label: {
    fontFamily: 'Inter-SemiBold',
    fontSize: 10.5,
  },
  labelBig: {
    fontSize: 11.5,
  },
});
